import { useState, useEffect } from 'react';
import useDataBean from '../../../../../../../../core/services/dataBean/useDataBean';
import useModal, { MODAL_LG, MODAL_md } from '../../../../../../../theme/Component/hooks/useModal';
import { Modal } from '../../../../../../../theme/Component/Modal';
import { BasicTable, MASK_DATE } from '../../../../../../../theme/Component/BasicTable';
import { OBsEditor } from '../../../../../../../contract/etapa-contrato/contrac/UBLInvoiceSupplier/Component/OBsEditor';
import { AccountEditor } from '../../../../../../../editor/AccountEditor';
import { InputDate } from '../../../../../../../theme/Input/InputDate';
import { _single } from '../../../../../../../../core/services/dataBean/EntityCatalog';
import { BasicButton } from '../../../../../../../theme/Component/BasicButton';
import { _AccountantBycatalog, _ByDocumentFactory, _ObligationBudget } from '../../../../../../../../core/services/dataBean/EntityCatalogVdos';
import { PrintJson } from '../../../../../../../theme/Component/PrintJson';
import usePaginator from '../../../../../../../theme/Component/usePaginator';


interface Props {
    idSelector: number;
    onChange: any;
    label?: string;
    returnType?: "ID" | "Object";
    render?: string;
    DocumentFactoryClass?: any;
}

export const AccountantConceptEditorCatalog = ({ idSelector, onChange, label, returnType = "ID", render, DocumentFactoryClass }: Props) => {

    const { instance, lista, setLista } = useDataBean(_AccountantBycatalog)
    const [id, setID] = useState(null);
    const [obseditor, setobseditor] = useState<any>({
        IDDocument: NaN,
        DocumentDate: NaN,
    })
    const paginador = usePaginator();
    const [account, setaccount] = useState<any>(null)
    const [paymentdate, setpaymentdate] = useState<any>(_single.getCurrenDate())
    const modal = useModal("Concepto para Registro de Reembolso de Terceros", MODAL_LG);
    useEffect(() => {
        setID(idSelector)
    }, [idSelector])

    useEffect(() => {
        getLista();
    }, [DocumentFactoryClass])

    const setValue = (e: string) => {
        const selectedId = parseInt(e);
        setID(selectedId);
        if (onChange) {
            const selectedItem = lista.find(
                (item) => item?.DataBeanProperties.IDAccountantConcept == e
            );
            if (selectedItem) {
                onChange(returnType === "Object" ? selectedItem?.DataBeanProperties : selectedId);
            } else {
                onChange(returnType === "Object" ? {} : null);
            }
        }
    };


    const getLista = () => {

        instance.getAccountantConceptCatalog(15,null,null,null,null,paginador.page, 15).then(
            (resp: any) => {
                 if (resp) {
                    //console.log(resp.NumberOfPages)
                    paginador.setPages(resp.NumberOfPages);
                    paginador.setRecords(resp.NumberOfPages * (15));
                    paginador.setRegiPerPage(15)

                    setLista(resp.List)
                }
            }
        ).catch(err => { console.log(err) })
    }
    const head = [
        // { title: 'ID', property: 'IDAccountantConcept', visible: true },
        // { title: 'Código', property: 'Code', visible: true },
        // { title: 'Nombre', property: 'Name', visible: true },
        // { title: 'Cuenta Contable', property: 'AccountantIDName', visible: true },
        // { title: 'Rubro Presupuestal', property: 'BudgetName', visible: true },
        { title: 'ID', property: 'IDAccountantConcept', visible: true },
                { title: 'Código', property: 'Code', visible: true },
                { title: 'Nombre', property: 'Name', visible: true },
                { title: 'Unidad de Negocio', property: 'BusinessCoreName', visible: true },
                { title: 'Tipo de Presupuesto', property: 'AccountantTypeName', visible: true },
                { title: 'Cuenta Contable del Concepto ', property: 'AccountantIDName', visible: true },
                { title: 'Cuenta Puente Contabilización', property: 'CreditAccountantIDName', visible: true },
                { title: 'Aplica a Cajas Menores', property: 'ApplyForCashDesk', visible: true },
                { title: 'Lista de Documentos a los que Aplica', property: 'JsonListName', visible: true },
                { title: 'Fecha de Creación', property: 'Since', visible: true, mask: MASK_DATE },
                { title: 'Rubro Presupuestal', property: 'BudgetName', visible: true },
                { title: 'No requiere compensación', property: 'DontRequiresCompensation', visible: true },
                { title: 'Tipo de Proceso', property: 'ProcessTypeName', visible: true },
                { title: 'Utilizar Responsable Compensación / Ingreso', property: 'CashFlowConceptName', visible: true },
                { title: 'Reponsable de Compensación de Ingreso', property: 'IncomeResponsibleName', visible: true }
    ]
    const abrirModal = () => {
        modal.open();
    }


    return (
        <>
            <label>{label ?? "Concepto para Registro de Reembolso de Terceros"}</label>
            <span className='form-control cursor ifmodal' onClick={abrirModal}>{render ?? ''}</span>
            <Modal modal={modal.modal} updateModal={modal.setModal}>
                <div className="row">
                    <div className="col-md-12">
                        <BasicTable head={head} body={lista} rowSet={(e) => { setValue(e.IDAccountantConcept); modal.close(); }} next={paginador.next}
                        pageTop={paginador.page}
                        back={paginador.back}
                        records={paginador}
                        customRows={15}></BasicTable>
                    </div>
                </div>



            </Modal>
        </>
    )
}